import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "banner" }
const _hoisted_2 = ["src"]

import { ref, onMounted } from 'vue'
import { asynchronousRetrieval } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'BannerC',
  setup(__props) {

const bannerUrl = ref('')

onMounted(async() => {
  const d: any = await asynchronousRetrieval('nfznxr-images/banner.png');
  bannerUrl.value = d;
  console.log('d', bannerUrl.value)

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", { src: bannerUrl.value }, null, 8, _hoisted_2)
  ]))
}
}

})